interface IFormTextReadonlyWrapper {
    value: string
    label: string
    className?: string
}

export default function FormTextReadonlyWrapper({ value, label, className }: IFormTextReadonlyWrapper) {
    return (
        <div className="form__readonly">
            <p className="small">{label}:</p>
            <p>{value}</p>
        </div>
    )
}